import { render } from "./ViewStudentDialog.vue?vue&type=template&id=1b72fe5c&scoped=true"
import script from "./ViewStudentDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentDialog.vue?vue&type=script&lang=js"

import "./ViewStudentDialog.vue?vue&type=style&index=0&id=1b72fe5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b72fe5c"]])

export default __exports__